import React from 'react';
import '../App.css';

function CoreValues() {
  const values = [
    { icon: '🚀', title: '驱动创新', desc: '高质量的专病数据资产与AI工具，为临床科研和医院发展注入强大动力。' },
    { icon: '⚡', title: '效率提升', desc: '自动化流程将医护人员从重复性工作中解放，服务患者数量和质量双重提升。' },
    { icon: '🌟', title: '体验升级', desc: '患者获得连续、个性化的贴心服务，提高满意度和依从性。' },
    { icon: '�', title: '商业模式', desc: '探索并启动多种商业模式，' },
    { icon: '🤝', title: '资源协同', desc: '打破信息孤岛，促进医疗资源在多中心、多部门间的高效流转与共享。' },
    { icon: '📊', title: '智慧决策', desc: '基于实时、全面的数据洞察，为管理层和临床医生提供科学的决策依据。' },
  ];
  return (
    <section id="core-values">
      <h2>开启数字化之旅，实现医疗健康服务效率与质量的全面提升</h2>
      <div className="cards-row">
        {values.map((v, i) => (
          <div className="card" key={i}>
            <div className="card-icon">{v.icon}</div>
            <div className="card-title">{v.title}</div>
            <div className="card-desc">{v.desc}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
export default CoreValues; 